import { render, staticRenderFns } from "./IssueEmpty.vue?vue&type=template&id=2cb18ac2&"
import script from "./IssueEmpty.vue?vue&type=script&lang=ts&"
export * from "./IssueEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports